import { Link, useNavigate } from "react-router-dom";
import shape1 from "../images/icons/shape1.png";
// import shape2 from "../images/icons/shape2.png";
import shape3 from "../images/icons/shape3.png";
import shape4 from "../images/icons/shape4.png";
import shape5 from "../images/icons/shape5.png";
import useMobile from "../hooks/useMobile";

const Breadcrumb = ({ heading, title, subTitle, goBack }) => {
  const navigate = useNavigate();
  const mobile = useMobile();
  return (
    <section className={`breadcrumb ${mobile ? 'custom-mobile-py-120' : 'custom-py-120'} bg-main-25 position-relative z-1 overflow-hidden mb-0`}>
      <img
        src={shape1}
        alt=""
        className="shape two d-md-block d-none"
      />
      {/* <img
        src={shape2}
        alt=""
        className="shape two animation-scalation d-md-block d-none"
      /> */}
      <img
        src={shape3}
        alt=""
        className="shape eight d-md-block d-none"
      />
      <img
        src={shape5}
        alt=""
        className="shape six d-md-block d-none"
      />
      <img src={shape4} alt="" className="shape four" />
      <img src={shape4} alt="" className="shape nine" />
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="breadcrumb__wrapper">
              <h1 className={`breadcrumb__title ${mobile ? 'display-6' : 'display-4'} fw-semibold text-center`}>
                {" "}
                {heading}
              </h1>
              <ul
                className="breadcrumb__list d-flex align-items-center justify-content-center gap-4"
                style={{ flexWrap: "wrap" }}
              >
                <li className="breadcrumb__item">
                  <Link
                    to="/"
                    className="breadcrumb__link text-neutral-500 hover-text-main-600 fw-medium"
                  >
                    <i className="text-lg d-inline-flex ph-bold ph-house" />{" "}
                    Home
                  </Link>
                </li>

                <li className="breadcrumb__item ">
                  <i className="text-neutral-500 d-flex ph-bold ph-caret-right" />
                </li>
                <li className="breadcrumb__item">
                  {subTitle ? (
                    goBack ? (
                      <button
                        onClick={() => navigate(-1)}
                        className="breadcrumb__link text-neutral-500 hover-text-main-600 fw-medium"
                      >
                        {title}
                      </button>
                    ) : (
                      <span className="text-neutral-500">{title}</span>
                    )
                  ) : (
                    <span className="text-main-two-600">{title}</span>
                  )}
                </li>

                {subTitle && (
                  <>
                    <li className="breadcrumb__item ">
                      <i className="text-neutral-500 d-flex ph-bold ph-caret-right" />
                    </li>
                    <li className="breadcrumb__item">
                      <span className="text-main-two-600"> {subTitle} </span>
                    </li>
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Breadcrumb;
